import { render, staticRenderFns } from "./WalletOnHomepage.vue?vue&type=template&id=70eb9bc6&scoped=true&"
import script from "./WalletOnHomepage.vue?vue&type=script&lang=js&"
export * from "./WalletOnHomepage.vue?vue&type=script&lang=js&"
import style0 from "./WalletOnHomepage.vue?vue&type=style&index=0&id=70eb9bc6&lang=scss&scoped=true&"
import style1 from "./WalletOnHomepage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb9bc6",
  null
  
)

export default component.exports